import {Lens} from '@dhmk/zustand-lens'
import {LanguagesType} from '@/features/country/types'

type ChatFavTopicsState = {languages: Record<string, string>}

const getLanguagesForStore = (list: LanguagesType[]) =>
    list.reduce((acc, language) => Object.assign({[language.code]: language.name}, acc), {})

type ChatFavTopicsActions = {
    setLanguages: (languages: LanguagesType[]) => void
}

export type ChatFavTopics = ChatFavTopicsState & ChatFavTopicsActions

const initialModal: ChatFavTopicsState = {
    languages: {}
}

const createChatFavTopicsSlice: Lens<ChatFavTopics> = set => ({
    ...initialModal,

    setLanguages: languages => set(() => ({languages: getLanguagesForStore(languages)}))
})

export default createChatFavTopicsSlice
